import { Button } from 'antd'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { strVal } from '../../../modules/Utils'

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 150,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/hseq/mrn/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'PO Code',
    accessor: 'purchases.code',
    width: 150,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/Order/${strVal(original, 'purchases._id').replace(
            'purchases/',
            '',
          )}`,
        }}
        style={{ marginLeft: '10px' }}>
        {value}
      </Link>
    ),
  },
  { Header: 'Title', accessor: 'title', style: { alignment: 'left', marginLeft: '10px' } },
  {
    Header: 'Company',
    accessor: 'company.fn',
    width: 250,
    hideable: true,
    hideDefault: true,
  },
  { Header: 'Vendor', accessor: 'vendor.fn', width: 250 },
  { Header: 'Country', accessor: 'delivery.country', width: 350 },
  /*{
    Header: 'purchases',
    accessor: 'purchases',
    Cell: ({value}) => `[${value.code}] ${value.title}`,
  },*/
  //{Header: 'Address', accessor: 'delivery.address.label'},
  { Header: 'PO Delivery date', accessor: 'delivery.date', Cell: DateCell, width: 250 },
  { Header: 'Status', accessor: 'status', Cell: StatusCell, width: 150 },
]

//req(h)/salesOrder code/POL/sale
function MRNList(props) {
  const { list, fetch, fetching, company, onChangeCompany, hideCompany, hideCreate } = props
  console.log({ props })
  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      CreateButton={() =>
        hideCreate !== true && (
          <Button
            type={'primary'}
            size="small"
            icon={'plus'}
            onClick={() => {
              props.history.push({
                pathname: `/hseq/mrn/new/`,
              })
            }}>
            New
          </Button>
        )
      }
      columns={columns}
    />
  )
}

MRNList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
MRNList.defaultProps = {}

export default withRouter(MRNList)
